import React, { Component } from "react";
import styled from "styled-components";
import {withRouter} from 'react-router-dom';
import instructionSheets from "../data/instructionSheets.js";



class Login extends Component {
constructor(props) {
    super(props);
	this.state = {taskUserIdTemp:""}

	this.handleSubmitTaskUserId = this.handleSubmitTaskUserId.bind(this);
	this.handleChangeTaskUserId = this.handleChangeTaskUserId.bind(this);	
}	
	// task-user id to move to App.js
handleChangeTaskUserId = (event) =>{
	this.setState({
		taskUserIdTemp: event.target.value
	})
}

//leveling up taskUserId to App
handleSubmitTaskUserId (event) {
	event.preventDefault();
	this.props.onSubmitTaskUserId(this.state.taskUserIdTemp)
	
	// move to Align page
	this.props.history.push('/align')
}	
	
	

 render() {
	 
	 return (
	<div>
		<InstructionContainer>
		<h2> Hexagons game </h2>
		Play the role of the Executor <br/><br/>
		
		<div style={{textAlign:"left"}}>
		Insert a drawing procedure index between 0 and 619 (including) 
		and start executing instructions. 
		<br/><small> *Please use a desktop device
		</small>
		</div>
		</InstructionContainer>	
		
		<form onSubmit={this.handleSubmitTaskUserId}>				
			<input name= "taskId" onChange={this.handleChangeTaskUserId} type="text" />
			<button type="submit">Submit</button>
		</form>
		
		 
	  
	</div>
	 )
	}	
}

export default withRouter(Login);


const Containter = styled.div`
  display: flex;
  flex-direction: column;
`;


const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;

`;
